class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchWrapper = this.closest('.search-wrapper');
    this.header = this.closest('.header') || document;
    this.label = this.header.querySelectorAll('.search-label');
    this.clearButton = this.querySelector('.clear-search-button');
    this.form = this.querySelector('form.search-form');

    this.toggleSearchInput();
    this.closeOutClick();
    this.attachClearButton();

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.form.addEventListener('submit', (event) => {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        event.preventDefault()
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  toggleSearchInput() {
    this.label.forEach((label) => {
      label.addEventListener('click', () => {
        this.searchWrapper.classList.toggle('show');
      })
    })
  }

  closeOutClick() {
    document.addEventListener("click", (event) => {
      const isLabelClick = Array.from(this.label).some(label => label.contains(event.target));
      const isWrapperClick = this.searchWrapper.querySelector('.clear-search-button').contains(event.target);
      const isInputClick = this.input.contains(event.target);

      if ((!isLabelClick && !isInputClick) || isWrapperClick) {
        this.searchWrapper.classList.remove('show');

        this.input.value = '';
        this.close();
        this.predictiveSearchResults.innerHTML = '';
        return;
      }
    })
  }

  getSearchResults(searchTerm) {
    const fields = 'title,product_type,tag,variants.title';
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[options][fields]=${fields}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  attachClearButton() {
    if (!this.clearButton) return;

    this.clearButton.addEventListener('click', () => {
      this.input.value = '';
      this.close();
      this.predictiveSearchResults.innerHTML = '';
      this.input.focus();
    });
  }

  open() {
    this.predictiveSearchResults.classList.add('shown');
  }

  close() {
    this.predictiveSearchResults.classList.remove('shown');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
